import { FilterCondSessionStorageKey } from '../constants/storageKey';

export function getCondStorageKey(condGameIds?: string[]) {
  if (!condGameIds?.length) {
    return FilterCondSessionStorageKey;
  }
  return `${FilterCondSessionStorageKey}__${[...condGameIds].sort().join(',')}`;
}

export function getFilterCondConfig(storageKey = FilterCondSessionStorageKey) {
  const condData = sessionStorage.getItem(storageKey);
  if (condData === null) return {};
  try {
    const data = JSON.parse(condData);
    return data;
  } catch (error) {
    console.log(error)
    return {};
  }
}

export function saveFilterCondConfig(
  data: { [key: string]: any },
  storageKey = FilterCondSessionStorageKey,
) {
  const condData = getFilterCondConfig(storageKey);

  const newCondData = { ...condData, ...(data || {}) };
  try {
    sessionStorage.setItem(
      FilterCondSessionStorageKey,
      JSON.stringify(newCondData),
    );
  } catch (error) {

  }

  sessionStorage.setItem(
    storageKey,
    JSON.stringify(newCondData),
  );
}
